export enum ERROR {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  INVALID_RESPONSE_TYPE = 'INVALID_RESPONSE_TYPE',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  NO_RESOURCE_FOUND = 'NO_RESOURCE_FOUND',
  SCHEMA_VALIDATION_ERROR = 'SCHEMA_VALIDATION_ERROR',
  RETRY_REQUIRE = 'RETRY_REQUIRE',
}
